/**
 * True when every numeric field in the reachability report (nested) is exactly 0.
 * Used only to decide SDK setup sidebar visibility — not for displaying counts.
 */
export function isReachabilityReportAllZeros(report) {
  if (report == null || typeof report !== 'object') {
    return false;
  }

  const walk = (node) => {
    if (node === null || node === undefined) {
      return true;
    }
    const t = typeof node;
    if (t === 'number') {
      return node === 0 && !Number.isNaN(node);
    }
    if (Array.isArray(node)) {
      return node.every(walk);
    }
    if (t === 'object') {
      return Object.values(node).every(walk);
    }
    return true;
  };

  return walk(report);
}
